<template>
  <div>
    <v-dialog
      max-width="550px"
      max-height="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Asset Category
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row justify="center">
          <v-col cols="12" md="6" lg="6">
              <h3 style="text-align:center">Category Name</h3>
              <v-text-field
                v-model="currentCategory.Dev_Skills_Category_Description"
                :readonly="!editMode"
                ></v-text-field>
            </v-col>
          </v-row>
          <div class="mx-3">
            <h2 class="mb-4" style="text-align:start">Subcategories</h2>
            <v-divider></v-divider>
            <v-data-table
              dense
              fixed-header
              :headers="headers"
              height="300px"
              :items="employeeSkillsSubcategories"
              :items-per-page="-1"
              :hide-default-footer="true"
            >
              <!-- Items -->
              <template v-slot:[`item.Dev_Skills_Subcategory_Description`]="{ item, index }">
                <v-text-field
                  v-if="editSubcategoryMode === index"
                  v-model="item.Dev_Skills_Subcategory_Description"
                ></v-text-field>
                  <span v-else>{{ item.Dev_Skills_Subcategory_Description }}</span>
              </template>
              <!-- /Items -->
              <template v-slot:[`item.Can_Delete`]="{ item, index }">
                <v-btn
                  icon
                  small
                  :disabled="addNewMode || (editSubcategoryMode > -1 && editSubcategoryMode !== index)"
                  :color="editSubcategoryMode === index ? 'success' : 'primary'"
                  @click.prevent="updateSubcategory(index, item)"
                >
                  <v-icon>{{editSubcategoryMode === index ? 'mdi-check-circle' : 'mdi-pencil-circle'}}</v-icon>
                </v-btn>
                <v-btn
                  v-if="editSubcategoryMode === index"
                  icon
                  small
                  color="primary"
                  @click.prevent="cancelSubcategoryEditing(index, item)"
                >
                  <v-icon>mdi-close-circle</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  color="red darken-2"
                  :disabled="addNewMode || (editSubcategoryMode > -1 && editSubcategoryMode !== index)"
                  v-if="editSubcategoryMode !== index"
                  @click.prevent="openDeleteSubcategoryDialog(index, item)"
                >
                  <v-icon>mdi-delete-circle</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`body.append`]>
                <td
                  class="px-2 text-no-wrap"
                  :class="{
                  'v-data-table__divider': addNewMode
                  }"
                >
                  <v-text-field
                    v-if="addNewMode"
                    text
                    v-model="subCategoryItem.Dev_Skills_Subcategory_Description"
                  ></v-text-field>
                </td>
                <td v-if="editMode" class="text-center text-no-wrap">
                  <v-btn
                    :disabled="editSubcategoryMode > -1"
                    small
                    icon
                    color="success"
                    @click.prevent="addNewSubcategoryToggle"
                  >
                    <v-icon>{{ addNewMode ? 'mdi-check-circle' : 'mdi-plus-circle' }}</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="addNewMode"
                    small
                    icon
                    color="primary"
                    @click.prevent="addNewMode = false"
                  >
                    <v-icon>mdi-close-circle</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveCategory"> {{editMode ? 'Save' : 'Edit'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="deleteSubcategoryDialog"
      v-model="deleteSubcategoryDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :message="deleteSubcategoryMessage"
      @onDeleteClick="confirmDeleteSubcategory"
      @onCancelClick="closeDeleteSubcategoryDialog"
      @onCloseClick="closeDeleteSubcategoryDialog"
    />
  </div>
</template>
<script>

export default {
  name: 'EmployeeSkillsEditor',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue')
  },
  props: {
    value: {
      required: false
    },
    currentCategory: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    },
    employeeSkillsSubcategories: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      editMode: false,
      editSubcategoryMode: -1,
      addNewMode: false,
      subCategoryItem: {
        Dev_Skills_Subcategory_ID: null,
        Dev_Skills_Category_ID: null,
        Dev_Skills_Subcategory_Description: ''
      },
      deleteSubcategoryDialog: false,
      subcategoryToDelete: null
    }
  },
  computed: {
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    deleteSubcategoryMessage () {
      if (!this.subcategoryToDelete || !this.subcategoryToDelete.item) return ''
      return this.subcategoryToDelete.item.Can_Delete === false
        ? 'This skill has employee data. Delete the skill and all related data?'
        : 'Delete this skill?'
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.editMode = false
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    headers () {
      const res = [
        {
          text: 'Subcategory Name',
          value: 'Dev_Skills_Subcategory_Description',
          divider: true,
          class: 'px-2 text-no-wrap'
        }
      ]
      if (this.editMode) {
        res.push({
          text: '#',
          align: 'center',
          value: 'Can_Delete',
          cellClass: 'px-2 text-no-wrap',
          class: 'px-2 text-no-wrap',
          width: '20%'
        })
      }
      return res
    }
  },
  mounted () {
  },
  methods: {
    saveCategory () {
      if (this.addMode && this.editMode) {
        const body = {
          Dev_Skills_Category_Description: this.currentCategory.Dev_Skills_Category_Description,
          Subcategories: this.employeeSkillsSubcategories
        }
        this.axios.post('/api/employee_skills/category', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'New category successfully added' })
          this.show = false
          this.editMode = false
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else if (this.editMode) {
        const body = {
          Dev_Skills_Category_ID: this.currentCategory.Dev_Skills_Category_ID,
          Dev_Skills_Category_Description: this.currentCategory.Dev_Skills_Category_Description
        }
        this.axios.put(`/api/employee_skills/category/${this.currentCategory.Dev_Skills_Category_ID}`, body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.$store.dispatch('setSuccess', { successMsg: 'Current category successfully updated' })
          this.show = false
          this.editMode = false
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.editMode = true
      }
    },
    addNewSubcategoryToggle () {
      if (this.addNewMode && !this.addMode) {
        this.subCategoryItem.Dev_Skills_Category_ID = this.currentCategory.Dev_Skills_Category_ID
        this.axios.post('/api/employee_skills_subcategory', this.subCategoryItem, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.subCategoryItem.Dev_Skills_Subcategory_ID = res.data[0].Dev_Skills_Subcategory_ID
          this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully added' })
          const newSubcategory = {
            Dev_Skills_Subcategory_ID: this.subCategoryItem.Dev_Skills_Subcategory_ID,
            Dev_Skills_Category_ID: this.subCategoryItem.Dev_Skills_Category_ID,
            Dev_Skills_Subcategory_Description: this.subCategoryItem.Dev_Skills_Subcategory_Description
          }
          this.employeeSkillsSubcategories.push(newSubcategory)
          this.clearSubcategoryItem()
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else if (this.addNewMode && this.addMode) {
        const subcategory = {
          Dev_Skills_Subcategory_ID: null,
          Dev_Skills_Category_ID: null,
          Dev_Skills_Subcategory_Description: this.subCategoryItem.Dev_Skills_Subcategory_Description
        }
        this.employeeSkillsSubcategories.push(subcategory)
        this.clearSubcategoryItem()
      } else {
        this.clearSubcategoryItem()
      }
      this.addNewMode = !this.addNewMode
    },
    clearSubcategoryItem () {
      this.subCategoryItem.Dev_Skills_Subcategory_ID = null
      this.subCategoryItem.Dev_Skills_Category_ID = null
      this.subCategoryItem.Dev_Skills_Subcategory_Description = ''
    },
    updateSubcategory (index, item) {
      if (this.editSubcategoryMode > -1) {
        const body = {
          Dev_Skills_Subcategory_ID: item.Dev_Skills_Subcategory_ID,
          Dev_Skills_Category_ID: this.currentCategory.Dev_Skills_Category_ID,
          Dev_Skills_Subcategory_Description: item.Dev_Skills_Subcategory_Description
        }
        this.axios.put(`/api/employee_skills/subcategory/${body.Dev_Skills_Subcategory_ID}`, body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          for (let i = 0; i < this.employeeSkillsSubcategories.length; i++) {
            if (this.employeeSkillsSubcategories[i].Dev_Skills_Subcategory_ID === item.Dev_Skills_Subcategory_ID) {
              this.employeeSkillsSubcategories[i] = res.data[0]
              break
            }
          }
          this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully updated' })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.subCategoryItem.Dev_Skills_Subcategory_ID = item.Dev_Skills_Subcategory_ID
        this.subCategoryItem.Dev_Skills_Category_ID = item.Dev_Skills_Category_ID
        this.subCategoryItem.Dev_Skills_Subcategory_Description = item.Dev_Skills_Subcategory_Description
      }
      this.editSubcategoryMode = this.editSubcategoryMode > -1 ? -1 : index
    },
    cancelSubcategoryEditing (index, item) {
      item.Dev_Skills_Subcategory_Description = this.subCategoryItem.Dev_Skills_Subcategory_Description
      this.editSubcategoryMode = -1
    },
    openDeleteSubcategoryDialog (index, item) {
      this.subcategoryToDelete = { index, item }
      this.deleteSubcategoryDialog = true
    },
    closeDeleteSubcategoryDialog () {
      this.deleteSubcategoryDialog = false
      this.subcategoryToDelete = null
    },
    confirmDeleteSubcategory () {
      if (!this.subcategoryToDelete) return
      const { index, item } = this.subcategoryToDelete
      this.axios.delete(`/api/employee_skills/subcategory/${item.Dev_Skills_Subcategory_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.employeeSkillsSubcategories.splice(index, 1)
        this.$store.dispatch('setSuccess', { successMsg: 'Subcategory successfully deleted' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      }).finally(() => {
        this.closeDeleteSubcategoryDialog()
      })
    }
  }
}
</script>
